import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';

import { useAppDispatch, useAppSelector } from '@redux/hooks';
import {
  candidateDetailsSelectors,
  fetchCandidateVideoInterviewUrl,
} from '@redux/candidateDetails';
import { Loader } from '@components';
import { Box } from '@mui/material';
import { isStatusLoading } from '@utils';

const videoStyle = { width: '100%', height: '100%', display: 'block' };

interface IVideoInterviewPlayerProps {
  videoUrlAPI: string;
  playing: boolean;
  onAspectRatio?: (ratio: number) => void;
}

export const VideoInterviewPlayer: React.FC<IVideoInterviewPlayerProps> = ({
  videoUrlAPI,
  playing,
  onAspectRatio,
}) => {
  const dispatch = useAppDispatch();
  const apiStatus = useAppSelector(
    candidateDetailsSelectors.getCandidateSelectedVideoInterviewUrlApiStatus,
  );

  const selectedRecordUrl = useAppSelector(
    candidateDetailsSelectors.getCandidateSelectedVideoInterviewUrl,
  );

  useEffect(() => {
    if (videoUrlAPI) {
      dispatch(
        fetchCandidateVideoInterviewUrl({
          videoUrlAPI: videoUrlAPI,
        }),
      );
    }
  }, [videoUrlAPI]);

  const isLoading = isStatusLoading(apiStatus);

  const reportAspectRatio = ({
    currentTarget,
  }: React.SyntheticEvent<HTMLVideoElement>) => {
    const { videoWidth, videoHeight } = currentTarget;
    if (videoWidth && videoHeight) onAspectRatio?.(videoWidth / videoHeight);
  };

  return (
    <Box position="relative" width="100%" height="100%">
      {isLoading && <Loader zIndex={2} />}
      <ReactPlayer
        controls
        playing={playing}
        width="100%"
        height="100%"
        url={selectedRecordUrl ?? ''}
        config={{
          file: {
            attributes: {
              style: videoStyle,
              onLoadedMetadata: reportAspectRatio,
            },
          },
        }}
        style={{
          background: 'black',
          borderRadius: '4px',
        }}
      />
    </Box>
  );
};
